import { useEffect, useState } from "react";
import { useApiClient } from "../../../hooks/useApiClient";
import { getTeamEmployees } from "../../../services/employeeTeamsService";
import { ITeamEmployeeTable } from "../interfaces/ITeamEmployeeInterface";

export function useTeamEmployees(segment: string = "my-team") {
  const { call, ready } = useApiClient();
  const [data, setData] = useState<ITeamEmployeeTable[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!ready) return;

    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      setData(null);
      try {
        const response = await call(getTeamEmployees, segment);
        if (!cancelled) {
          setData(response);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err as Error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [ready, segment, call]);

  return { data, loading, error };
}
